// src/api/admin/inactiveLenders.js
import { api } from "../client";
import { API_BASE_URL } from "../../utils/constants";

const METHOD_PATH = `${API_BASE_URL}/api/method/dynesourcerapi.lender_activity.get_inactive_lenders`;

/**
 * Get inactive lenders (30+ days without login)
 * @param {Object} params - Query parameters
 * @param {string} params.from_date - Start date (YYYY-MM-DD)
 * @param {string} params.to_date - End date (YYYY-MM-DD)
 * @param {number} params.page - Page number (default: 1)
 * @param {number} params.page_size - Page size (default: 50)
 * @returns {Promise<Object>} Response with data array
 */
export async function getInactiveLenders(params = {}) {
  const response = await api.get(METHOD_PATH, { params });
  
  // Handle different response formats
  const data = response?.data;
  if (data?.message) {
    return data.message;
  }
  if (Array.isArray(data)) {
    return {
      data,
      total: data.length,
      page: 1,
      page_size: data.length,
    };
  }
  return data || {};
}

export default getInactiveLenders;
